module.exports = __webpack_public_path__ + "static/media/smiling.647eed3d.svg";